/** Colores del pulso para lo que la conversación consiguió. Spec 022. */

export type Conseguido = 'reserva' | 'cancelacion' | 'modificacion'

export const ETIQUETA_CONSEGUIDO_CORTA: Record<Conseguido, string> = {
    reserva: 'Reservó',
    cancelacion: 'Anuló',
    modificacion: 'Cambió',
}

export const TEXTO_CONSEGUIDO: Record<Conseguido, string> = {
    reserva: 'text-emerald-400',
    cancelacion: 'text-amber-400',
    modificacion: 'text-sky-400',
}

export const PUNTO_CONSEGUIDO: Record<Conseguido, string> = {
    reserva: 'bg-emerald-400',
    cancelacion: 'bg-amber-400',
    modificacion: 'bg-sky-400',
}

export const CAJA_CONSEGUIDO: Record<Conseguido, string> = {
    reserva: 'border-emerald-900/60 bg-emerald-950/30 text-emerald-300',
    cancelacion: 'border-amber-900/60 bg-amber-950/30 text-amber-300',
    modificacion: 'border-sky-900/60 bg-sky-950/30 text-sky-300',
}
